<button (click)="exportToXLS($event)">
    <img src="/assets/excel.png" alt="Export to Excel" style="width: 20px; height: 20px">
</button>
<app-input-dialog #exportExcelDialog title="Export to Excel IS COMING SOON!!!" (stepChanged)="exportStepChanged($event)" (cancelled)="exportCancelled()">
    <input-dialog-step [button]="exportButton">
        @if (downloadsNotAllowed) {
        <ngb-alert type="danger" [dismissible]="false">
            Downloads are not available to demo users.
        </ngb-alert>
        } @else {
        @if (listing$ | async; as listing) {

        @if (listing.total > 20000) {
        <ngb-alert type="danger" [dismissible]="false">
            <strong>You can only export a maximum of 20,000 rows at a time</strong>
        </ngb-alert>
        } @else {
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="table_id" [checked]="downloadParts['table']" (change)="downloadParts['table'] = !downloadParts['table']">
            <label class="form-check-label" for="table_id">Include Table Contents</label>
        </div>
        @for (part of downloadParts | keyvalue; track part.key) {
        @let friendlyName = tableLookup[part.key];

        @if (friendlyName) {
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="{{ part.key }}" [checked]="downloadParts[part.key]" (change)="downloadParts[part.key] = !downloadParts[part.key]">
            <label class="form-check-label" for="{{ part.key }}">Include {{ friendlyName }} information</label>
        </div>
        }
        }
        }
        }
        }
    </input-dialog-step>
    <input-dialog-step button="">
        <p>{{ exportProgressMessage }}</p>
        <ngb-progressbar [striped]="true" [animated]="true" [value]="exportProgress"></ngb-progressbar>
    </input-dialog-step>
</app-input-dialog>
<iframe style="display: none;" [src]="exportDownloadURL | safe: 'resourceUrl'"></iframe>